import React from 'react';
import spam from '../assets/images/spam.png';

const TokenExpired = () => {
  return (
    <div className='flex flex-col justify-center items-center h-screen'>
      <div
        style={{ backgroundImage: `URL(${spam})` }}
        className='h-2/5 w-96 bg-center bg-no-repeat'
      />
      <h3 className='p-5 text-center'>
        We're sorry, it appears that your verification link has expired. Please
        contact us{' '}
        <span>
          <a
            href='mailto:sims.admin@dmsinetwork.com'
            className='cursor-pointer hover:underline text-dms-primary'
          >
            here
          </a>{' '}
        </span>
        for access.
      </h3>
    </div>
  );
};

export default TokenExpired;
